package pl.decks.chartjs.radar.options

import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption

data class LayoutOptions(
    val padding: Int? = null,
    val paddingTop: Int? = null,
    val paddingBottom: Int? = null,
    val paddingLeft: Int? = null,
    val paddingRight: Int? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        if (padding != null) this.padding = padding.asDynamic()
        else {
            this.padding = jso {
                if (paddingTop != null) this.top = paddingTop.asDynamic()
                if (paddingBottom != null) this.bottom = paddingBottom.asDynamic()
                if (paddingLeft != null) this.left = paddingLeft.asDynamic()
                if (paddingRight != null) this.right = paddingRight.asDynamic()
            }
        }
    }
}
